module.exports = __webpack_public_path__ + "static/nova-7482ab6a7c2e745ae1bcc3f8cdb9d114.jpg";